var _style, _path, _g, _circle, _g2, _g3, _path2, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#D80027;}\n\t.st4{fill:#496E2D;}\n\t.st5{fill:#FFDA44;}\n\t.st6{fill:#338AF3;}\n\t.st7{fill:#F3F3F3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2H256z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 367.3,
    cy: 144.7,
    r: 44.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.5,33.4c-40,22.8-73.3,56.1-96.1,96.1V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,224.5l-91-91h-31.5v0L256,256h0C256,256,256,234.3,256,224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.4,133.6h155.8v66.8H289.4V133.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445.2,256L445.2,256L445.2,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.4,256L289.4,256L289.4,256z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M289.4,300.5V345h23.4c14,13.8,33.3,22.3,54.5,22.3s40.4-8.5,54.5-22.3h1.2h22.3v-44.5H289.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.4,189.2V256c0,59.6,77.9,77.9,77.9,77.9s77.9-18.3,77.9-77.9v-66.8L289.4,189.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.3,224.9c-19.5,0-19.5,17.8-39,17.8s-19.5-17.8-39-17.8v31.2c19.5,0,19.5,17.8,39,17.8s19.5-17.8,39-17.8 c19.5,0,19.5,17.8,39,17.8s19.5-17.8,39-17.8v-31.2c-19.5,0-19.5,17.8-39,17.8S386.8,224.9,367.3,224.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.3,162.5c-19.5,0-19.5,17.8-39,17.8s-19.5-17.8-39-17.8v31.2c19.5,0,19.5,17.8,39,17.8s19.5-17.8,39-17.8 c19.5,0,19.5,17.8,39,17.8s19.5-17.8,39-17.8v-31.2c-19.5,0-19.5,17.8-39,17.8S386.8,162.5,367.3,162.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/ky.c6d94017c4c1f90643c16a4b7fa925d8.svg";
export { ForwardRef as ReactComponent };